import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'
import { EmtTypography } from 'emt-components-v2'

interface ProgressProps {
  value: number
  color: string
}

export function Progress(props: ProgressProps) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        <CircularProgress
          variant="determinate"
          sx={{
            color: props.color,
            opacity: 0.2,
          }}
          size={52}
          thickness={4}
          value={100}
        />
        <CircularProgress
          variant="determinate"
          sx={{
            color: props.color,
            position: 'absolute',
          }}
          size={52}
          thickness={4}
          value={props.value}
        />

        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <EmtTypography variant="body2" fontWeight="bold" color={'#1D1929'}>{`${Math.round(
            props.value,
          )}%`}</EmtTypography>
        </Box>
      </Box>
    </Box>
  )
}
